import axios from "axios";
import { headersTokenConfig } from "../config/HeaderToken";

class PointAddition {
  list(page, limit, search, startDate, endDate, sort_by, sort_type) {
    const params = {
      start_date: startDate,
      end_date: endDate,
      page: page,
      limit: limit,
    };

    if (sort_by) {
      params.sort_by = sort_by;
    }

    if (sort_type) {
      params.sort_type = sort_type;
    }

    if (search) {
      params.search = search;
    }

    const endPoint = `/worker/salary/addition/point?` + new URLSearchParams(params).toString();
    let url = process.env.REACT_APP_API_URL_V2 + endPoint;

    return axios.get(url, headersTokenConfig);
  }

  post(payload) {
    const url = process.env.REACT_APP_API_URL_V2 + `/worker/salary/addition/point/posting`;
    return axios.post(url, payload, headersTokenConfig);
  }
}

export default new PointAddition();
